import { MSSPriceSectionId } from '@ace-clublabs/common-membership-api-types';
import { useGlobalState } from '../../../../state/state';
import { ManageMembershipPriceCartItem } from '../ManageMembershipPriceCartItem';

export const AddOnsPriceCartItem = () => {
  const [priceCart] = useGlobalState('priceCart');
  const addedProductAddOns = priceCart?.items?.find((p) => p.id === MSSPriceSectionId.RV_COST); // RV is the only applicable Add on

  return addedProductAddOns ? (
    <ManageMembershipPriceCartItem
      type="description"
      subtitle="Add-ons"
      className="product-add-ons-price-item"
      description={addedProductAddOns?.description}
      price={addedProductAddOns?.price}
    />
  ) : (
    <></>
  );
};
